<template>
<ItpModal
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="MCompanyEditor"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      name="company"
      class="row"
      ref="mainForm"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpCol>
        <MCompanyEditorFieldset
          :item="editor"
          :formId="formId"
          :target="target"
        >
        </MCompanyEditorFieldset>
      </ItpCol>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Save'|pgettext('Button')"
      :disabled="!forms.company || !forms.company.submittable"
      type="submit"
      :form="formId"
      variant="primary"
      icon="fa-save"
      :spinning="actions.save.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpModal>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class MCompanyEditor extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "modal",
  };

  beforeCreate() {
  }

  getPayload(...args: any[]) {
    const [editor] = args
    console.log(editor)
    return {
      id: editor.id,
      etag: editor.getETAG(),
      ...editor.getChanges({ skipEmbeddedLists: true })
    };
  }

  @Prop({
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    type: String,
  })
  target!: string;

  @Watch('target')
  onTarget(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("target")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  defaultTitle!: any;
  targetConfig!: any;
  editor!: any;

  async $$load_editor() {
    return this.item.editor()
  }

  ux!: any;
  dataMembers = ['formId', 'defaultTitle', 'targetConfig', 'editor', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        formId: null,
        defaultTitle: this.$fn.pgettext("Company", "Edit General Information"),
        targetConfig: {
          general: {
            title: this.$fn.pgettext("Company", "Edit general data"),
            fieldsToSubmit: ["*"
              ,
            ]
            ,
          }
          ,
        }
        ,
        editor: null,
        ux: null,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.target ? this.targetConfig[this.target].title : this.defaultTitle,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_3658_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_3658, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeModal_3664_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1040167445267876_closeModal_3664, alias=undefined
    return {
      result: {
        ok: true,
        value: $event.data,
      }
      ,
    }
  }

  async act_1040167445267876_crud_3662_getActionArgs($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_1040167445267876_crud_3662, alias=save
    return {
      objectType: "company",
      op: "upsert",
      data: this.getPayload(this.editor),
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_1419464017721962_closeModal_3666_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1419464017721962_closeModal_3666, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
      }
      ,
    }
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_3658: actions.CloseModalAction;
    evh_7315092382398562_close_3657: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeModal_3660: actions.CloseModalAction;
    evh_2248226175642056_close_3659: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeModal_3664: actions.CloseModalAction;
    evh_1040167445267876_success_3663: actions.EventHandlerImpl;
    act_1040167445267876_crud_3662: actions.CRUDAction;
    evh_1040167445267876_submit_3661: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeModal_3666: actions.CloseModalAction;
    evh_1419464017721962_clickPreventStop_3665: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_3658 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_3658_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_3657 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_3658,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_3657],
      }
    );
    const act_2248226175642056_closeModal_3660 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_3659 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeModal_3660,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_3659],
      }
    );
    const act_1040167445267876_closeModal_3664 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1040167445267876_closeModal_3664_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_3663 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeModal_3664,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1040167445267876_crud_3662 = new actions.CRUDAction(
      {
        actionArgs: this.act_1040167445267876_crud_3662_getActionArgs,
        displayName: "save",
        events: [evh_1040167445267876_success_3663],
      }
    );
    const evh_1040167445267876_submit_3661 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_crud_3662,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_3661],
      }
    );
    const act_1419464017721962_closeModal_3666 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1419464017721962_closeModal_3666_getActionArgs,
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_3665 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeModal_3666,
        event: "click.prevent.stop",
        displayName: "closeModal",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_3665],
      }
    );
    return {
      act_7315092382398562_closeModal_3658,
      evh_7315092382398562_close_3657,
      evh_7315092382398562_close,
      act_2248226175642056_closeModal_3660,
      evh_2248226175642056_close_3659,
      evh_2248226175642056_close,
      act_1040167445267876_closeModal_3664,
      evh_1040167445267876_success_3663,
      act_1040167445267876_crud_3662,
      evh_1040167445267876_submit_3661,
      evh_1040167445267876_submit,
      act_1419464017721962_closeModal_3666,
      evh_1419464017721962_clickPreventStop_3665,
      evh_1419464017721962_clickPreventStop,
      save: act_1040167445267876_crud_3662,
    }
  }
}

Vue.component("MCompanyEditor", MCompanyEditor);

</script>